import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.PROD ? import.meta.env.VITE_SENTRY_DSN : "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllInputs: false,
      maskAllText: false,
      networkCaptureBodies: true,
      networkDetailAllowUrls: ["*"],
    }),
    Sentry.replayCanvasIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.contextLinesIntegration(),
  ],
  environment: import.meta.env.PROD ? "production" : "development",

  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  attachStacktrace: true,
  sendDefaultPii: false,
});
